<template>
  <div>
    <Modal title="active状态管理" v-model="visible" width="1000" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <div v-if="detail" class="page-form" style="padding-top: 0 !important;">
        <Form :model="detail" ref="formValidate" class="page-form" :label-width="100">
          <FormItem label="IFA姓名" prop="name"> {{ detail.englishName ? detail.englishName + '/' : '' }}{{ detail.name }} </FormItem>
          <FormItem label="入职时间" prop="entryTime">
            {{ detail.entryTime || '-' }}
          </FormItem>
        </Form>
      </div>
      <div class="table-box tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" max-height="500"> </Table>
        <Page
          :total="total"
          :current.sync="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          show-total
          @on-change="getList"
          style="text-align: center; margin-top: 20px"
        />
      </div>
    </Modal>
    <editActiveModal ref="editActiveModal" @success="getList"></editActiveModal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import _ from 'lodash';
import { pageTool, common } from '@/api/mixins';
import editActiveModal from './editActiveModal';
export default {
  components: { editActiveModal },
  props: {},
  mixins: [pageTool, common],
  data() {
    return {
      visible: false,
      loading: false,
      tableData: [],
      searchParams: {
        pageNo: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '核算时间',
          align: 'center',
          key: 'updateTime',
          render(h, params) {
            return <span>{dayjs(params.row.updateTime).format('YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '考核时间',
          align: 'center',
          key: 'year',
          render(h, params) {
            let quarter = params.row.quarter;
            let year = params.row.year;
            return <span>{year + '年第' + quarter + '季度'}</span>;
          }
        },
        {
          title: '保费金额(美元)',
          align: 'center',
          key: 'fee'
        },
        {
          title: '是否active',
          align: 'center',
          key: 'activeStatus',
          render(h, params) {
            return <span>{params.row.activeStatus == 1 ? '是' : '否'}</span>;
          }
        }
      ],
      detail: {}
    };
  },

  methods: {
    reset() {
      this.searchParams.pageNo = 1;
      this.getList();
    },
    getList() {
      console.log(this.searchParams);
      this.listLoading = true;
      this.$http({
        url: '/buz/userActiveRecord/read/list',
        type: 'POST',
        data: this.searchParams
      })
        .then(res => {
          this.listLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    open(data) {
      this.searchParams = {
        pageNo: 1,
        pageSize: 10
      };

      this.tableData = [];
      data = JSON.parse(JSON.stringify(data));
      if (data.entryTime) {
        data.entryTime = dayjs(data.entryTime).format('YYYY-MM-DD');
      }
      this.detail = data;
      this.visible = true;
      this.searchParams.userId = data.id;
      this.getList(true);
    }
  }
};
</script>
<style lang="scss" scoped>
.input-item {
  .ivu-select {
    flex: 1 !important;
  }
}
.search-box {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #e3461f;
  }
}

.table-box {
  .ivu-form-item {
    margin-bottom: 0;
  }
}

/deep/.ivu-modal-body {
  padding-right: 10px !important;
  padding-left: 10px !important;
}
</style>
